// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gyramais-upload-card {
  transition: 0.6s;
  box-shadow: none;
  border: 0.063rem solid #C9D3CC;
}
.gyramais-upload-card .upload-card-alert {
  margin-bottom: 0.5rem;
}
.gyramais-upload-card .ant-card-body {
  padding: 1.875rem 2.5rem;
}
@media (max-width: 768px) {
  .gyramais-upload-card .ant-card-body {
    padding: 1rem 1.5rem;
  }
}
.gyramais-upload-card .upload-button {
  display: flex;
  justify-content: flex-end;
}
.gyramais-upload-card .upload-button .upload-button-label {
  color: var(--primary-button-text-color);
}
.gyramais-upload-card .upload-button .gyramais-btn {
  padding: 0 !important;
}
.gyramais-upload-card .upload-button .ant-upload-select-text {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.gyramais-upload-card .upload-button .ant-upload-select-text span {
  display: flex;
  align-items: center;
  padding: 0 1.875rem;
  width: 100% !important;
  height: 100% !important;
}
@media (max-width: 768px) {
  .gyramais-upload-card .upload-button {
    align-items: center;
    margin-top: 2rem;
  }
  .gyramais-upload-card .upload-button .gyramais-btn {
    margin-top: 0.6rem;
    width: 100% !important;
  }
  .gyramais-upload-card .upload-button .gyramais-btn .upload-button-label {
    color: var(--primary-button-text-color);
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
  }
}
.gyramais-upload-card .centered-col {
  display: flex;
  align-items: center;
  justify-content: center;
}
.gyramais-upload-card .centered-col .loading-subtitle {
  opacity: 0.5;
}
.gyramais-upload-card .file-divider {
  margin-top: 1.875rem !important;
  margin-bottom: 1.875rem !important;
}
.gyramais-upload-card .gyramais-information.detailed {
  margin-bottom: 0 !important;
}
.gyramais-upload-card .gyramais-information .information-value {
  word-break: break-all;
}
.gyramais-upload-card .loading {
  text-align: center;
}
.gyramais-upload-card .loading img {
  margin-left: auto;
  margin-right: auto;
  width: 5rem;
  height: 5rem;
  margin-bottom: 2.5rem;
}
.gyramais-upload-card .loading .loading-text {
  font-size: 1.25rem;
  line-height: 1.625rem;
  color: var(--primary-color);
  font-weight: 300;
  margin-bottom: 0.5rem;
}
.gyramais-upload-card .loading .loading-sub-text {
  font-size: 1rem;
  line-height: 1rem;
  color: black;
  font-weight: 400;
  margin-bottom: 2rem;
}
.gyramais-upload-card .information-container {
  transition: 0.2s;
  padding: 0 0.6rem;
  padding-top: 0.6rem;
  border-radius: 1rem;
}
.gyramais-upload-card .information-container:hover {
  background-color: #00000010;
}
.gyramais-upload-card .upload-card-icon {
  color: var(--link-button-color);
  font-size: 1.6rem;
  cursor: pointer;
}
.gyramais-upload-card .upload-card-icon.danger-icon {
  color: var(--danger-color);
}
.gyramais-upload-card .document-tips-label {
  padding: 0 1.875rem;
  justify-self: center;
  align-self: center;
}
@media (min-width: calc(768px + 1px)) {
  .gyramais-upload-card {
    padding: 2.5rem !important;
  }
}
@media (max-width: 768px) {
  .gyramais-upload-card h4 {
    font-size: 1.25rem;
    line-height: 1.6rem;
  }
}
.gyramais-upload-card.incomplete {
  animation: warning 1.5s infinite;
}
`, "",{"version":3,"sources":["webpack://./src/components/cards/UploadCard/styles.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;EACA,8BAAA;AACF;AAJA;EAMI,qBAAA;AACJ;AAPA;EAUI,wBAAA;AAAJ;AAEI;EAAA;IACE,oBAAA;EACJ;AACF;AAfA;EAkBI,aAAA;EACA,yBAAA;AAAJ;AAnBA;EAsBM,uCAAA;AAAN;AAtBA;EAyBM,qBAAA;AAAN;AAzBA;EA6BM,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AADN;AA/BA;EAkCQ,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;AAAR;AAII;EAAA;IACE,mBAAA;IACA,gBAAA;EADJ;EADE;IAKI,kBAAA;IACA,sBAAA;EADN;EALE;IASM,uCAAA;IACA,aAAA;IACA,mBAAA;IACA,WAAA;IACA,uBAAA;EADR;AACF;AAvDA;EA8DI,aAAA;EACA,mBAAA;EACA,uBAAA;AAJJ;AA5DA;EAmEM,YAAA;AAJN;AA/DA;EAwEI,+BAAA;EACA,kCAAA;AANJ;AAUI;EACE,2BAAA;AARN;AAtEA;EAiFM,qBAAA;AARN;AAzEA;EAsFI,kBAAA;AAVJ;AA5EA;EAyFM,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AAVN;AAnFA;EAiGM,kBAAA;EACA,qBAAA;EACA,2BAAA;EACA,gBAAA;EACA,qBAAA;AAXN;AA1FA;EAyGM,eAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AAZN;AAjGA;EAkHI,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AAdJ;AAvGA;EAwHI,2BAAA;AAdJ;AA1GA;EA4HI,+BAAA;EACA,iBAAA;EACA,eAAA;AAfJ;AAgBI;EACE,0BAAA;AAdN;AAlHA;EAqII,mBAAA;EACA,oBAAA;EACA,kBAAA;AAhBJ;AAmBE;EAAA;IACE,0BAAA;EAhBF;AACF;AAiBE;EAAA;IAEI,kBAAA;IACA,mBAAA;EAfJ;AACF;AAkBE;EACE,gCAAA;AAhBJ","sourcesContent":[".gyramais-upload-card {\n  transition: .6s;\n  box-shadow: none;\n  border: .063rem solid #C9D3CC;\n\n  .upload-card-alert {\n    margin-bottom: .5rem;\n  }\n  \n  .ant-card-body {\n    padding: 1.875rem 2.5rem;\n\n    @media(max-width: @md-screen) {\n      padding: 1rem 1.5rem;\n    }\n  }\n\n  .upload-button {\n    display: flex;\n    justify-content: flex-end;\n\n    .upload-button-label {\n      color: var(--primary-button-text-color);\n    }\n    .gyramais-btn {\n      padding: 0 !important;\n    }\n    \n    .ant-upload-select-text {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      span {\n        display: flex;\n        align-items: center;\n        padding: 0 1.875rem;\n        width: 100% !important;\n        height: 100% !important;\n      }\n    }\n\n    @media(max-width: @md-screen) {\n      align-items: center;\n      margin-top: 2rem;\n\n      .gyramais-btn {\n        margin-top: .6rem;\n        width: 100% !important;\n\n        .upload-button-label {\n          color: var(--primary-button-text-color);\n          display: flex;\n          align-items: center;\n          width: 100%;\n          justify-content: center;\n        }\n      }\n    }\n  }\n\n  .centered-col {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .loading-subtitle {\n      opacity: .5;\n    }\n  }\n\n  .file-divider {\n    margin-top: 1.875rem !important;\n    margin-bottom: 1.875rem !important;\n  }\n\n  .gyramais-information {\n    &.detailed {\n      margin-bottom: 0 !important;\n    }\n    .information-value {\n      word-break: break-all;\n    }\n  }\n\n  .loading {\n    text-align: center;\n\n    img {\n      margin-left: auto;\n      margin-right: auto;\n      width: 5rem;\n      height: 5rem;\n      margin-bottom: 2.5rem;\n    }\n\n    .loading-text {\n      font-size: 1.25rem;\n      line-height: 1.625rem;\n      color: var(--primary-color);\n      font-weight: 300;\n      margin-bottom: .5rem\n    }\n\n    .loading-sub-text {\n      font-size: 1rem;\n      line-height: 1rem;\n      color: black;\n      font-weight: 400;\n      margin-bottom: 2rem;\n    }\n  }\n\n  .information-container {\n    transition: .2s;\n    padding: 0 .6rem;\n    padding-top: .6rem;\n    border-radius: 1rem;\n  }\n  .information-container:hover {\n    background-color: #00000010;\n  }\n  \n  .upload-card-icon {\n    color: var(--link-button-color);\n    font-size: 1.6rem;\n    cursor: pointer;\n    &.danger-icon {\n      color: var(--danger-color);\n    }\n  }\n\n  .document-tips-label {\n    padding: 0 1.875rem;\n    justify-self: center;\n    align-self: center;\n  }\n\n  @media(min-width: calc(@md-screen + 1px)) {\n    padding: 2.5rem !important;\n  }\n  @media(max-width: @md-screen) {\n    h4 {\n      font-size: 1.25rem;\n      line-height: 1.6rem;\n    }\n  }\n\n  &.incomplete {\n    animation: warning 1.5s infinite;\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
